/**
 * Reads the DEOC / division information the backend attaches to reports.
 *
 * Reports carry `deocDetails` (one entry per division) plus `primaryDeoc`, the
 * single entry that actually has a DEOC assigned. A report normally spans
 * several divisions - territorial, social forestry, flying squad - but only the
 * territorial one has a DEOC, so `primaryDeoc` is what should be displayed.
 *
 * Every method tolerates the fields being absent so older cached responses and
 * endpoints that have not been enriched simply render as "not available".
 */
export default {
  methods: {
    deocEntry(item) {
      if (!item) return null;
      if (item.primaryDeoc) return item.primaryDeoc;
      const list = Array.isArray(item.deocDetails) ? item.deocDetails : [];
      return list.find((entry) => entry && entry.deocName) || list[0] || null;
    },

    /**
     * Division to show against the case. Falls back to listing every division
     * name when none of them has a DEOC, so the row is still informative.
     */
    deocDivisionName(item) {
      const entry = this.deocEntry(item);
      if (entry && entry.divisionName) return entry.divisionName;
      const list = Array.isArray(item && item.deocDetails) ? item.deocDetails : [];
      const names = list.map((e) => e && e.divisionName).filter(Boolean);
      return names.length ? names.join(", ") : null;
    },

    deocName(item) {
      const entry = this.deocEntry(item);
      return entry && entry.deocName ? entry.deocName : null;
    },

    deocPhone(item) {
      const entry = this.deocEntry(item);
      return entry && entry.deocPhone ? entry.deocPhone : null;
    },
  },
};
